var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isErrorHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { css, html, LitElement } from 'lit';
import { customElement, query, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { router } from '../router/BoostPortalRouter';
import { BoostPortalMemberStandardProgress } from '../components/BoostPortalMemberStandardProgress';
import { BoostButton } from '../components/common/BoostButton';
import { BoostPortalChooseDepartment } from '../components/BoostPortalChooseDepartment';
import { BoostPortalChooseMembership, } from '../components/BoostPortalChooseMembership';
import { BoostPortalPersonalInformation, } from '../components/BoostPortalPersonalInformation';
import { BoostStatusContainer } from '../components/common/BoostStatusContainer';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { BoostPortalHeader } from '../components/BoostPortalHeader';
import { BoostStepIndicator, } from '../components/common/BoostStepIndicator';
import { BoostPortalPaymentOptions } from '../components/common/BoostPortalPaymentOptions';
import { DocumentViewer } from 'common-uicomponents/components/DocumentViewer';
import { BoostPortalPaymentSuccess } from '../components/common/BoostPortalPaymentSuccess';
import { Callback } from '../enums/Callback';
import { BoostPortalNavigationSteps } from '../enums/BoostPortalNavigationSteps';
import { TrackingFactorySingleton } from '../tracking/TrackingFactorySingleton';
import { TrackingEvent } from '../tracking/TrackingEvent';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
import { BoostVippsPaymentController } from '../controllers/BoostVippsPaymentController';
import { BoostLoading } from '../components/common/BoostLoading';
import { ewExerciseProfileJson } from 'boost-api/schemas/ewExerciseProfileJson';
import { canCreateMember } from '../helpers/canCreateMember';
import { canUpdateMember } from '../helpers/canUpdateMember';
let BoostPortalRegisterMemberViewWithPayment = class BoostPortalRegisterMemberViewWithPayment extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.memberIsUnderaged = false;
        this.meetsMinimumAge = true;
        this.meetsShortTermMinimumAge = true;
        this.isSponsorSetup = false;
        this.memberExists = false;
        this.isDirectLink = false;
        this.isTestMembership = false;
        this.filteredMemberships = [];
        this.vippsPaymentController = new BoostVippsPaymentController(this);
    }
    static get is() {
        return 'boost-portal-register-member-view-with-payment';
    }
    static get styles() {
        return css `
            :host {
                width: 100%;
                padding: 1rem;
            }

            h3 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 10px;
            }

            a:link,
            a:visited,
            a:active {
                text-decoration: underline;
                color: var(--portalLink, #2a9ba3);
            }

            a:hover {
                text-decoration: none;
            }

            .submit {
                padding-top: 25px;
            }

            @media only screen and (max-width: 800px) {
                .submit {
                    padding-top: 0px;
                }
            }
        `;
    }
    /** @override */ render() {
        return html `
            <boost-portal-header
                .disabled="${this.vippsPaymentController.isCallbackNets ||
            this.vippsPaymentController.isCallbackVipps}"
                .viewLoginButton="${false}"
            ></boost-portal-header>

            <boost-step-indicator
                .currentStep="${this.vippsPaymentController.currentStep}"
                .steps="${this._getSteps(this.vippsPaymentController.currentStep)}"
                @currentStep-changed="${(event) => {
            this.vippsPaymentController.setCurrentStep(event.detail.currentStep);
        }}"
            ></boost-step-indicator>
            ${this._getViewForCurrentStep(this.vippsPaymentController.currentStep)}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.popCallback = () => this.vippsPaymentController.urlController.getParameterDataFromHistoryState();
        window.addEventListener('popstate', this.popCallback);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (!this.popCallback) {
            return;
        }
        window.removeEventListener('popstate', this.popCallback);
    }
    _tokenObserver() {
        return __awaiter(this, void 0, void 0, function* () {
            const sponsorSetupResult = yield MembersignupAPI.getV1BoostsignupSponsorsetup();
            if (isErrorHTTP(sponsorSetupResult)) {
                SnackBar.pushError(sponsorSetupResult.error);
                return;
            }
            this.isSponsorSetup = sponsorSetupResult.status;
        });
    }
    _memberHandler(event) {
        if (this.session && this.loggedInProfile && this.loggedInProfile.memberid) {
            this._updateMember(event);
            return;
        }
        this._createMember(event);
    }
    _updateMember(event) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            const updateParams = {
                memberInformation: this.memberInformation,
                loggedInMemberId: (_a = this.loggedInProfile) === null || _a === void 0 ? void 0 : _a.memberid,
                isValidMemberInformation: this._isValidMemberInformation(),
                selectedDepartmentId: this.selectedDepartmentId,
                selectedMembershipId: this.selectedMembershipId,
            };
            if (!canUpdateMember(updateParams)) {
                return;
            }
            const buttonElement = event.target;
            if (buttonElement.disabled) {
                return;
            }
            updateParams.memberInformation.membershipId = updateParams.selectedMembershipId;
            updateParams.memberInformation.departmentId = updateParams.selectedDepartmentId;
            updateParams.memberInformation.netsCallbackUrl =
                this.vippsPaymentController.urlController.buildNetsCallbackUrl(this.vippsPaymentController.urlController.shortTerm, this.vippsPaymentController.urlController.noDirectDebit, this.centerShort);
            this.requestUpdate('memberInformation');
            this.vippsPaymentController.setRegisteredMember(updateParams.memberInformation);
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(updateParams.memberInformation));
            buttonElement.setLoading(true);
            const updatedMemberResult = yield MembersignupAPI.putV1BoostsignupMemberUsingMemberId(updateParams.loggedInMemberId, updateParams.memberInformation);
            if (isErrorHTTP(updatedMemberResult)) {
                SnackBar.pushError(updatedMemberResult.error);
                return;
            }
            const createMembershipResult = yield MembersignupAPI.postV1BoostsignupMemberContractUsingMemberId(updatedMemberResult.memberId, {
                membershipId: updateParams.selectedMembershipId,
                departmentId: updateParams.selectedDepartmentId,
                netsCallbackUrl: updateParams.memberInformation.netsCallbackUrl,
            });
            if (isErrorHTTP(createMembershipResult)) {
                SnackBar.pushError(createMembershipResult.error);
                return;
            }
            updateParams.memberInformation.invoiceId = createMembershipResult.invoiceId;
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(updateParams.memberInformation));
            if (this.vippsPaymentController.urlController.noDirectDebit) {
                if (updateParams.memberInformation.invoiceId) {
                    this.vippsPaymentController.setInvoiceId(updateParams.memberInformation.invoiceId);
                }
                this.vippsPaymentController.setCallback(Callback.NETS);
                this.vippsPaymentController.setCurrentStep(BoostPortalNavigationSteps.PAYMENT);
            }
            else {
                // TODO denne burde kanskje vært awaited, for å være sikker
                // på at tracking er fullført før man sendes avgårde...
                // men vi fikk noe problemer, så vi deaktiverer det enn så lenge.
                TrackingFactorySingleton.asyncTracker((tracker) => tracker.completedEvent(TrackingEvent.BankIDSigningStarted));
                updateParams.memberInformation.link_to_nets = createMembershipResult.link_to_nets;
                window.location.replace(updateParams.memberInformation.link_to_nets);
            }
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(updateParams.memberInformation));
            buttonElement.setLoading(false);
        });
    }
    _createMember(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const createParams = {
                memberExists: this.memberExists,
                memberInformation: this.memberInformation,
                isValidMemberInformation: this._isValidMemberInformation(),
                selectedDepartmentId: this.selectedDepartmentId,
                selectedMembershipId: this.selectedMembershipId,
            };
            if (!canCreateMember(createParams)) {
                return;
            }
            const buttonElement = event.target;
            this.memberExists = false;
            createParams.memberInformation.membershipId = createParams.selectedMembershipId;
            createParams.memberInformation.departmentId = createParams.selectedDepartmentId;
            createParams.memberInformation.netsCallbackUrl =
                this.vippsPaymentController.urlController.buildNetsCallbackUrl(this.vippsPaymentController.urlController.shortTerm, this.vippsPaymentController.urlController.noDirectDebit, this.centerShort);
            this.requestUpdate('memberInformation');
            buttonElement.setLoading(true);
            const createdMemberResult = yield MembersignupAPI.postV1BoostsignupMember(createParams.memberInformation);
            if (isErrorHTTP(createdMemberResult)) {
                if (createdMemberResult.error.http_status === 409) {
                    this.memberExists = true;
                }
                else {
                    SnackBar.pushError(createdMemberResult.error);
                }
                return;
            }
            this.vippsPaymentController.setRegisteredMember(createdMemberResult);
            this.dispatch(BoostPortalStore.Actions.SetMemberInformation(createdMemberResult));
            // TODO denne burde kanskje vært awaited, for å være sikker
            // på at tracking er fullført før man sendes avgårde...
            // men vi fikk noe problemer, så vi deaktiverer det enn så lenge.
            TrackingFactorySingleton.asyncTracker((tracker) => tracker.completedEvent(TrackingEvent.PersonalInformationFilled));
            if (this.vippsPaymentController.urlController.noDirectDebit) {
                if (createdMemberResult.invoiceId) {
                    this.vippsPaymentController.setInvoiceId(createdMemberResult.invoiceId);
                }
                this.vippsPaymentController.setCallback(Callback.NETS);
                this.vippsPaymentController.setCurrentStep(BoostPortalNavigationSteps.PAYMENT);
            }
            else {
                window.location.replace(createdMemberResult.link_to_nets);
            }
            buttonElement.setLoading(false);
        });
    }
    _getSteps(currentStep) {
        const steps = [
            {
                title: this.boostTranslate('center'),
                isActive: currentStep === BoostPortalNavigationSteps.DEPARTMENT,
                subtitle: '',
            },
            {
                title: this.boostTranslate('personalia'),
                isActive: currentStep === BoostPortalNavigationSteps.INFORMATION,
                subtitle: '',
            },
            {
                title: this.boostTranslate('signing'),
                isActive: currentStep === BoostPortalNavigationSteps.DIRECTDEBIT,
                subtitle: '',
            },
            {
                title: this.boostTranslate('payment'),
                isActive: currentStep === BoostPortalNavigationSteps.PAYMENT,
                subtitle: '',
            },
            {
                title: this.boostTranslate('succeed'),
                isActive: currentStep === BoostPortalNavigationSteps.SUCCESS,
                subtitle: '',
            },
        ];
        const shortTermMembershipSteps = [
            {
                title: this.boostTranslate('center'),
                isActive: currentStep === BoostPortalNavigationSteps.DEPARTMENT,
                subtitle: '',
            },
            {
                title: this.boostTranslate('personalia'),
                isActive: currentStep === BoostPortalNavigationSteps.INFORMATION,
                subtitle: '',
            },
            {
                title: this.boostTranslate('payment'),
                isActive: currentStep === BoostPortalNavigationSteps.PAYMENT,
                subtitle: '',
            },
            {
                title: this.boostTranslate('succeed'),
                isActive: currentStep === BoostPortalNavigationSteps.SUCCESS,
                subtitle: '',
            },
        ];
        if (this.vippsPaymentController.urlController.noDirectDebit) {
            return shortTermMembershipSteps;
        }
        return steps;
    }
    _isValidMemberInformation() {
        if (!this.memberInformation || !this.boostPortalPersonalInformation) {
            return false;
        }
        return this.boostPortalPersonalInformation.validateFields();
    }
    _routeToPrivateSponsor() {
        window.history.pushState(null, document.title, `${router.baseUrl + this.centerShort}/member/private`);
        window.dispatchEvent(new PopStateEvent('popstate'));
    }
    _getViewForCurrentStep(currentStep) {
        if (this.vippsPaymentController.isCallbackVipps &&
            ![BoostPortalNavigationSteps.PAYMENT, BoostPortalNavigationSteps.SUCCESS].includes(this.vippsPaymentController.currentStep)) {
            return html `<div
                style="padding: 3rem; background-color: white; border-radius: 6px; margin-top: 3rem;"
            >
                <boost-loading title="Venter på betaling"></boost-loading>
            </div>`;
        }
        switch (currentStep) {
            case BoostPortalNavigationSteps.DEPARTMENT:
                return this._renderDepartmentMembershipOptions();
            case BoostPortalNavigationSteps.INFORMATION:
                return this._renderPersonalInformation();
            case BoostPortalNavigationSteps.PAYMENT:
                return this._renderPaymentOptions();
            case BoostPortalNavigationSteps.SUCCESS:
                return this._renderPaymentSuccess();
        }
    }
    _renderDepartmentMembershipOptions() {
        return html `
            <boost-portal-choose-department></boost-portal-choose-department>

            ${this.selectedDepartmentId
            ? html ` <boost-portal-choose-membership
                      @filtered-memberships-changed="${(event) => (this.filteredMemberships = event.detail.value)}"
                  ></boost-portal-choose-membership>`
            : html `<div style="padding-bottom:16px;"></div>`}
            ${this.selectedMembershipId
            ? html `<div class="submit">
                      <boost-button
                          type="submit"
                          name="${this.boostTranslate('next-button')}"
                          @click="${() => this._changeStepToInformation()}"
                          ?disabled="${this._getDisabledState()}"
                      >
                      </boost-button>
                  </div>`
            : ''}
        `;
    }
    _getDisabledState() {
        if (this.isDirectLink) {
            return false;
        }
        else if (this.loggedInProfile && Boolean(this.isTestMembership)) {
            return true;
        }
        else if (!this.filteredMemberships.length) {
            return true;
        }
        return !this.selectedDepartmentId || !this.selectedMembershipId;
    }
    _changeStepToInformation() {
        var _a, _b, _c;
        if (!this.selectedDepartmentId || !this.selectedMembershipId || !this.filteredMemberships.length) {
            return;
        }
        if (this.loggedInProfile && this.isTestMembership) {
            return;
        }
        const membershipId = this.selectedMembershipId;
        const membershipName = (_c = (_b = (_a = this.memberships) === null || _a === void 0 ? void 0 : _a.find((membership) => membership.id == membershipId)) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : 'Medlemskap med ukjent navn ' + membershipId;
        TrackingFactorySingleton.asyncTracker((tracker) => tracker.completedEvent(TrackingEvent.SelectedMembership, { membershipId, membershipName }));
        this.vippsPaymentController.setCurrentStep(BoostPortalNavigationSteps.INFORMATION);
    }
    _renderPaymentOptions() {
        return html `<boost-portal-payment-options
            .invoice="${this.vippsPaymentController.getInvoice()}"
            .noDirectDebit="${this.vippsPaymentController.urlController.noDirectDebit}"
            .selectedMembership="${this.selectedMembership}"
            .callback="${this.vippsPaymentController.urlController.callback}"
            .shortTerm="${this.vippsPaymentController.urlController.shortTerm}"
            @currentStep-changed="${(event) => this.vippsPaymentController.setCurrentStep(event.detail.currentStep)}"
        ></boost-portal-payment-options>`;
    }
    _renderPaymentSuccess() {
        return html `<boost-portal-payment-success></boost-portal-payment-success>`;
    }
    _renderPersonalInformation() {
        return html `<boost-portal-personal-information
                id="boostPortalPersonalInformation"
                @memberPhoneNumber-changed="${() => (this.memberExists = false)}"
                @memberIsUnderaged-changed="${(event) => (this.memberIsUnderaged = event.detail.memberIsUnderaged)}"
                @meetsMinimumAge="${(event) => {
            this.meetsMinimumAge = event.detail.value;
            this.requestUpdate('meetsMinimumAge');
        }}"
                @meetsShortTermMinimumAge="${(event) => {
            this.meetsShortTermMinimumAge = event.detail.value;
        }}"
                @memberExists-changed="${(event) => (this.memberExists = event.detail.memberExists)}"
            ></boost-portal-personal-information>

            ${this.memberExists
            ? html `
                      <boost-status-container type="info">
                          ${this.boostTranslateOutputHtml('earlier-member', {
                url: router.baseUrl + this.centerShort + '/login',
            })}
                      </boost-status-container>
                  `
            : this._renderMemberAge()}`;
    }
    _renderMemberAge() {
        var _a, _b, _c, _d, _e;
        if (!this.meetsMinimumAge) {
            return html `<boost-status-container type="info">
                ${this.boostTranslateOutputHtml('under-age', {
                age: (_c = (_b = (_a = this.center) === null || _a === void 0 ? void 0 : _a.minimum_age) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '18',
            })}
            </boost-status-container>`;
        }
        return html ` ${!this.memberIsUnderaged && this.meetsShortTermMinimumAge
            ? html `
                  <div class="next-button">
                      <div style="padding:25px 10px 10px 10px">
                          ${!((_d = this.selectedMembership) === null || _d === void 0 ? void 0 : _d.no_direct_debit)
                ? html `<span>${this.boostTranslate('almost-complete-registered')}</span>`
                : html `<span>${this.boostTranslate('confirm-registered')}</span>`}
                      </div>
                      ${!((_e = this.selectedMembership) === null || _e === void 0 ? void 0 : _e.no_direct_debit)
                ? html ` <boost-button
                                type="submit"
                                name="${this.boostTranslate('confirm-and-sign')}"
                                .disabled="${this.memberExists}"
                                @click="${(event) => this._memberHandler(event)}"
                            >
                            </boost-button>`
                : html `<boost-button
                                type="submit"
                                name="${this.boostTranslate('proceed-to-payment')}"
                                .disabled="${this.memberExists}"
                                @click="${(event) => this._memberHandler(event)}"
                            >
                            </boost-button>`}
                  </div>
              `
            : html `${this._statusContainerViewBasedOnAge()} `}`;
    }
    _statusContainerViewBasedOnAge() {
        var _a, _b, _c, _d, _e, _f;
        if (!this.meetsShortTermMinimumAge && ((_a = this.selectedMembership) === null || _a === void 0 ? void 0 : _a.no_direct_debit)) {
            return html `<boost-status-container type="info">
                ${this.boostTranslateOutputHtml('short-term-membership-under-age', {
                age: (_d = (_c = (_b = this.center) === null || _b === void 0 ? void 0 : _b.short_term_minimum_age) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '18',
            })}
            </boost-status-container> `;
        }
        else if ((_e = this.selectedMembership) === null || _e === void 0 ? void 0 : _e.no_direct_debit) {
            return html ` <div style="padding:25px 10px 10px 10px">
                    <span>${this.boostTranslate('confirm-registered')}</span>
                </div>
                <boost-button
                    type="submit"
                    name="${this.boostTranslate('proceed-to-payment')}"
                    @click="${(event) => this._memberHandler(event)}"
                >
                </boost-button>`;
        }
        if (this.isSponsorSetup && !((_f = this.selectedMembership) === null || _f === void 0 ? void 0 : _f.no_direct_debit)) {
            return html `<boost-status-container type="info">
                    ${this.boostTranslate('sponsor-under-age')}
                </boost-status-container>

                <boost-button
                    type="submit"
                    name="${this.boostTranslate('sponsor-under-age-button')}"
                    @click="${() => this._routeToPrivateSponsor()}"
                    width-full
                ></boost-button>`;
        }
        else {
            return html `<boost-status-container type="info">
                ${this.boostTranslate('under-age-description')}
            </boost-status-container> `;
        }
    }
    _membershipsObserver() {
        if (this.memberships && this.selectedMembershipId) {
            this.selectedMembership = this.memberships.find((membership) => membership.id === this.selectedMembershipId);
        }
    }
    _memberInformationObserver() {
        var _a;
        if (!this.memberInformation) {
            return;
        }
        this.vippsPaymentController.setRegisteredMember(this.memberInformation);
        if ((_a = this.selectedMembership) === null || _a === void 0 ? void 0 : _a.no_direct_debit) {
            this.vippsPaymentController.urlController.invoiceId = this.memberInformation.invoiceId
                ? this.memberInformation.invoiceId
                : 0;
        }
    }
    _selectedMembershipObserver() {
        if (this.selectedMembership) {
            this.vippsPaymentController.urlController.shortTerm = this.selectedMembership.temporary;
            this.vippsPaymentController.urlController.noDirectDebit = this.selectedMembership.no_direct_debit;
            this.isTestMembership = this.selectedMembership.test_membership;
        }
    }
    _selectedDepartmentIdObserver() {
        if (!this.selectedDepartmentId) {
            return;
        }
        this.vippsPaymentController.setSelectedDepartmentId(this.selectedDepartmentId);
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'token':
                    this._tokenObserver();
                    break;
                case 'memberships':
                case 'selectedMembershipId':
                    this._membershipsObserver();
                    break;
                case 'memberInformation':
                    this._memberInformationObserver();
                    break;
                case 'selectedMembership':
                    this._selectedMembershipObserver();
                    break;
                case 'selectedDepartmentId':
                    this._selectedDepartmentIdObserver();
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalRegisterMemberViewWithPayment._deps = [
    BoostButton,
    BoostStepIndicator,
    BoostPortalChooseDepartment,
    BoostPortalChooseMembership,
    BoostPortalPersonalInformation,
    BoostPortalMemberStandardProgress,
    BoostStatusContainer,
    BoostPortalHeader,
    BoostPortalPaymentOptions,
    DocumentViewer,
    BoostPortalPaymentSuccess,
    BoostLoading,
];
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberViewWithPayment.prototype, "centerShort", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('center')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberViewWithPayment.prototype, "center", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberInformation')),
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberViewWithPayment.prototype, "memberInformation", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "memberIsUnderaged", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "meetsMinimumAge", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "meetsShortTermMinimumAge", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberViewWithPayment.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedMembershipId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalRegisterMemberViewWithPayment.prototype, "selectedMembershipId", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "isSponsorSetup", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('token')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberViewWithPayment.prototype, "token", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('session')),
    state(),
    __metadata("design:type", String)
], BoostPortalRegisterMemberViewWithPayment.prototype, "session", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "memberExists", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('loggedInProfile')),
    state(),
    __metadata("design:type", ewExerciseProfileJson)
], BoostPortalRegisterMemberViewWithPayment.prototype, "loggedInProfile", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('memberships')),
    state(),
    __metadata("design:type", Array)
], BoostPortalRegisterMemberViewWithPayment.prototype, "memberships", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('isDirectLink')),
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "isDirectLink", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], BoostPortalRegisterMemberViewWithPayment.prototype, "selectedMembership", void 0);
__decorate([
    query('#boostPortalPersonalInformation'),
    __metadata("design:type", BoostPortalPersonalInformation)
], BoostPortalRegisterMemberViewWithPayment.prototype, "boostPortalPersonalInformation", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalRegisterMemberViewWithPayment.prototype, "isTestMembership", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], BoostPortalRegisterMemberViewWithPayment.prototype, "filteredMemberships", void 0);
BoostPortalRegisterMemberViewWithPayment = __decorate([
    customElement(BoostPortalRegisterMemberViewWithPayment.is)
], BoostPortalRegisterMemberViewWithPayment);
export { BoostPortalRegisterMemberViewWithPayment };
